import React, { useState, useEffect, useRef } from "react";
import { APIProvider, useMapsLibrary } from "@vis.gl/react-google-maps";
import {
  Box,
  TextField,
  List,
  ListItemButton,
  ListItemText,
  Paper,
} from "@mui/material";
import LocationOnIcon from "@mui/icons-material/LocationOn";

const API_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;

// -------------------- INNER COMPONENT --------------------
// const PlacesAutocompleteInput = ({ onPlaceSelect, className }) => {
//   const [input, setInput] = useState("");
//   const [predictions, setPredictions] = useState([]);
//   const [autocompleteService, setAutocompleteService] = useState(null);
//   const [placesService, setPlacesService] = useState(null);
//   const isUserInput = useRef(true); 


//   const placesLib = useMapsLibrary("places");

//   useEffect(() => {
//     console.log("PlacesAutocompleteInput useEffect placesLib:", placesLib);
//     console.log("PlacesAutocompleteInput useEffect placesLib:", window.google);
//     if (!placesLib || !window.google) return;

//     if (!autocompleteService) {
//       setAutocompleteService(new window.google.maps.places.AutocompleteService());
//     }

//     if (!placesService) {
//       setPlacesService(
//         new window.google.maps.places.PlacesService(document.createElement("div"))
//       );
//     }
//   }, [placesLib]);

//   useEffect(() => {
//     if (!autocompleteService || !input) {
//       setPredictions([]);
//       return;
//     }
//     if (isUserInput.current) {
//       autocompleteService.getPlacePredictions({ input }, (results, status) => {
//         if (
//           status === window.google.maps.places.PlacesServiceStatus.OK &&
//           results
//         ) {
//           setPredictions(results);
//         } else {
//           setPredictions([]);
//         }
//       });
//     }
//   }, [input, autocompleteService]);


//   const handleSelect = (placeId, description) => {
//     isUserInput.current = false; 
//     setPredictions([]);
//     setInput(description); 

//     if (!placesService) return;

//     placesService.getDetails(
//       {
//         placeId,
//         fields: ["name", "formatted_address", "geometry"],
//       },
//       (place, status) => {
//         if (
//           status === window.google.maps.places.PlacesServiceStatus.OK &&
//           place
//         ) {
//           onPlaceSelect?.(place);
//         }
//       }
//     );
//   };

//   return (
//     <Box className={className} >
//       <TextField
//         label="Address"
//         id="address"
//         name="address"
//         variant="outlined"
//         fullWidth
//         value={input}
//         onChange={(e) =>{   isUserInput.current = true; setInput(e.target.value)}}
//         autoComplete="off"
//       />
//       {predictions.length > 0 && (

//         <List
//           className="shadow-lg"
//         >
//           {predictions.map((prediction, index) => (
//             <ListItemButton
//               key={prediction.place_id}
//               onClick={() =>
//                 handleSelect(
//                   prediction.place_id,
//                   prediction.description
//                 )
//               }
//             >
//               <LocationOnIcon sx={{ mr: 2 }} color="action" />
//               <ListItemText
//                 primary={prediction.structured_formatting.main_text}
//                 secondary={prediction.structured_formatting.secondary_text}
//               />
//             </ListItemButton>
//           ))}
//         </List>

//       )}
//     </Box>
//   );
// };
const PlacesAutocompleteInput = ({
  onPlaceSelect,
  className,
  value: propValue,
  onChange: propOnChange,
  onBlur,
  name = "address",
  error,
  helperText,
  size = "normal",
  required,
  formik
}) => {
  const [input, setInput] = useState("");
  const [predictions, setPredictions] = useState([]);
  const [autocompleteService, setAutocompleteService] = useState(null);
  const [placesService, setPlacesService] = useState(null);
  const isUserInput = useRef(true);

  const placesLib = useMapsLibrary("places");

  const value = propValue !== undefined ? propValue : input;
  const handleInputChange = (e) => {
    isUserInput.current = true;
    const newValue = e.target.value;

    // Call controlled prop change
    if (propOnChange) {
      propOnChange(e);

    } else {
      setInput(newValue);
    }
  };

  useEffect(() => {

    if (!placesLib || !window.google) return;
    if (!autocompleteService) {
      setAutocompleteService(new window.google.maps.places.AutocompleteService());
    }

    if (!placesService) {
      setPlacesService(
        new window.google.maps.places.PlacesService(document.createElement("div"))
      );
    }
  }, [placesLib]);

  useEffect(() => {

    if (!autocompleteService || !value) {
      setPredictions([]);
      return;
    }

    if (isUserInput.current) {
      autocompleteService.getPlacePredictions({ input: value }, (results, status) => {
        if (
          status === window.google.maps.places.PlacesServiceStatus.OK &&
          results
        ) {
          setPredictions(results);
        } else {
          setPredictions([]);
        }
      });
    }
  }, [value, autocompleteService]);

  const extractZipCode = (addressComponents) => {
    const postalCodeComponent = addressComponents?.find(component =>
      component.types.includes("postal_code")
    );
    return postalCodeComponent?.long_name || null;
  };

  const handleSelect = (placeId, description) => {
    isUserInput.current = false;
    setPredictions([]);
    let zipCode = "";
    if (propOnChange) {
      propOnChange({
        target: {
          name,
          value: description,
        },
      });
    } else {
      setInput(description);
    }
    if (placesService) {

      placesService.getDetails(
        {
          placeId,
          fields: ["name", "formatted_address", "geometry", "address_components"],
        },
        (place, status) => {
          if (
            status === window.google.maps.places.PlacesServiceStatus.OK &&
            place
          ) {
            console.log("Selected place details:", place);

            zipCode = extractZipCode(place.address_components);
            console.log("Extracted zip code:", zipCode);
            if (propOnChange && zipCode) {
              console.log("we are in set field");
              formik.setFieldValue('zipcode', zipCode); 
           
            }
            onPlaceSelect?.({ ...place, zipCode });
            // onPlaceSelect?.(place);
          }
        }
      );
    }

  };

  return (
    <Box className={className}>
      <TextField
        label="Address"
        id={name}
        required={required}
        name={name}
        variant="outlined"
        fullWidth
        size={size}
        value={value}
        onChange={handleInputChange}
        onBlur={onBlur}
        autoComplete="off"
        error={error}
        helperText={helperText}
      />
      {predictions.length > 0 && (
        <List className="shadow-lg">
          {predictions.map((prediction) => (
            <ListItemButton
              key={prediction.place_id}
              onClick={() =>
                handleSelect(prediction.place_id, prediction.description)
              }
            >
              <LocationOnIcon sx={{ mr: 2 }} color="action" />
              <ListItemText
                primary={prediction.structured_formatting.main_text}
                secondary={prediction.structured_formatting.secondary_text}
              />
            </ListItemButton>
          ))}
        </List>
      )}
    </Box>
  );
};

// export default PlacesAutocompleteInput
const GooglePlacesAutocomplete = ({

  onPlaceSelect,
  className,
  value,
  onChange,
  onBlur,
  name,
  error,
  helperText,
  size,
  required = false,
  formik
}) => {
  return (
    <APIProvider apiKey={API_KEY} libraries={["places"]}>
      <PlacesAutocompleteInput {...{
        onPlaceSelect,
        className,
        value,
        onChange,
        onBlur,
        name,
        error,
        helperText,
        size,
        required,
        formik
      }} />
    </APIProvider>
  );
};

export default GooglePlacesAutocomplete;


